import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { SaveSliderRequestBody, SliderItem } from 'api/types/slider'

class Slider {
  // get all brokers a user belongs to
  async getSliderList(): Promise<SliderItem[] | (AxiosError | Error)> {
    const url = APIRoutes.slider.getSliderList
    return ApiProvider.getRequest(url) as Promise<
      SliderItem[] | (AxiosError | Error)
    >
  }

  async saveSlider(
    slide: SaveSliderRequestBody,
  ): Promise<any | (AxiosError | Error)> {
    const url = APIRoutes.slider.saveSlider
    const formData = new FormData()

    if (slide.id != null) {
      formData.append('id', String(slide.id))
    }

    formData.append('title', slide.title ?? '')
    formData.append('content', slide.content ?? '')
    formData.append('link', slide.link ?? '')

    return ApiProvider.postRequest(url, formData, true) as Promise<
      any | (AxiosError | Error)
    >
  }

  async addSliderFiles({
    slideId,
    file,
  }: {
    slideId: number
    file: File
  }): Promise<any | (AxiosError | Error)> {
    const url = APIRoutes.slider.addSliderFiles
    const formData = new FormData()
    formData.append('id', slideId.toString())
    formData.append(`files[0].file`, file)
    formData.append(`files[0].label`, 'Imagem')

    return ApiProvider.postRequest(url, formData, true) as Promise<
      any | (AxiosError | Error)
    >
  }

  async removeSliderFile({
    sliderId,
    fileId,
  }: {
    sliderId: string
    fileId: string
  }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.slider.removeSliderFile}?sliderId=${sliderId}&fileId=${fileId}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }
}

export const sliderService = new Slider()
